export default __webpack_public_path__ + "static/media/marca_balcao_govbr.70f82c7e.png";